// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller($scope, $state, HardTokenSyncService) {

    $scope.hardTokenSync = {};
    $scope.isTrackerValid = false;

    var tracker = $state.params.tracker;

    if (tracker) {
        HardTokenSyncService.get({
            trackerId: tracker
        }).$promise.then(function (data) {
            $scope.isTrackerValid = true;
            $scope.hardTokenSyncInfo = data;
        }, function (error) {
            $scope.topLevelMessage = new SpAlert('danger', error.data.message);
        });
    }

    const captcha = $scope.captcha = new Captcha({isVisible: () => true});
    $scope.synchronize = function (form) {

        $scope.hardTokenSync.captchaResponse = captcha.response;

        var data = {};
        if ($scope.isTrackerValid) {
            data.trackerId = $scope.hardTokenSyncInfo.trackerId;
        }

        HardTokenSyncService.save(data, $scope.hardTokenSync).$promise.then(function (data) {
            $scope.topLevelMessage = new SpAlert('success', 'hard_token_sync.messages.success');

        }, function (error) {
            if (error.status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new SpAlert('danger', error.data.message);
            }
        })
        .finally(() => captcha.reset());

        $scope.hardTokenSync = {};
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-sync/hard-token-sync.controller.js